import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-contract-details',
  templateUrl: './contract-details.component.html',
  styleUrls: ['./contract-details.component.scss']
})
export class ContractDetailsComponent implements OnInit {


    productId: string | null = null;
  investor: any = {
    name: '',
    email: '',
    phone: '',
    password: '',
    job_title_id: ''
  };

   employeeId: string | null = null;
  contracts: any;
  contractsId: string;
  contractDetails: any;
  installments: any;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService
  ) {}
    ngOnInit(): void {
    // get product id from route
   this.contractsId = this.route.snapshot.paramMap.get('id');
    if (this.contractsId) {
      this.getContractsById(this.contractsId);
    }


        
  }



  
  getContractsById(id: string): void {
    this.apiService.contractsById(id).subscribe({
      next: (res: any) => {
        this.contractDetails = res?.data || {};
        this.installments =  res?.data?.installments || {}
        console.log( 'response from investor :',this.contractDetails )
        console.log( 'response from contracts :',this.installments )
      },
      error: (err) => {
        console.error('Failed to load investor:', err);
        this.toastr.error('Failed to load investor details');
      },
    });
  }


getInstallmentRatio(inst: any): number {
  const amount = Number(inst?.amount || 0);
  const max = Number(inst?.amount_max || 0);

  if (!max || max === 0) {
    return 0;
  }

  return +((amount / max) * 100).toFixed(1);
}

}
